module.exports = __webpack_public_path__ + "assets/webgl/camera_path.9ef9e7d6.bin";